import React from "react";
import DetailOverview from "../../components/organism/DaftarAnggota";
const PageDaftarAnggota = () => {
  return (
    <>
      <DetailOverview />
    </>
  );
};

export default PageDaftarAnggota;